import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
   selector: 'app-top-widget-panel',
   standalone: true,
   imports: [CommonModule],
   templateUrl: './top-widget-panel.component.html',
   styleUrls: ['./top-widget-panel.component.scss']
})
export class TopWidgetPanelComponent {
   @Input() unclaimedCount: number = 0;
   @Input() followUpCount: number = 0;
   @Input() mentionCount: number = 0;
   @Input() outstandingCount: number = 0;
   @Input() activeWidget: string = 'unclaimed';

   @Output() widgetClick = new EventEmitter<string>();

   onWidgetClick(widgetType: string) {
      if (widgetType === 'outstanding') {
         this.widgetClick.emit('outstanding');
      } else {
         this.activeWidget = widgetType;
         this.widgetClick.emit(widgetType);
      }
   }
}
